import axios from "axios";

export default function SafetyeducationResultDeleteService(formData, educationId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/safety/education/" + educationId + "/results",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
